import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { t } from "i18next";
import { CLASSNAME } from "utils/constant";
import { FC } from "react";
import CellPopover from "ui/grid/DescriptionCell";

export const fisheryDepartmentNoteGridColumns = ({
	onPrint,
}: {
	onPrint?: (data: any) => void;
}): GridColumnProps[] => [
	{
		field: "noteNumber",
		title: t("NoteNumber"),
		width: "160px",
		headerClassName: "no-border",
	},
	{
		field: "landingTime",
		title: t("Date"),
		width: "120px",
		headerClassName: "no-border",
		cells: {
			data: (props) => (
				<GrideDateFormatter
					date={props.dataItem.landingTime}
					formatType={"dd.MM.yyyy"}
				/>
			),
		},
	},
	{
		field: "vesselRegistrationId",
		title: t("VesselRegistrationNo"),
		width: "110px",
		headerClassName: "no-border",
	},
	{
		field: "vesselName",
		title: t("VesselName"),
		headerClassName: "no-border",
	},
	{
		field: "catchField",
		title: t("CatchArea"),
		// width: "200px",

		cells: { data: (props) => <CellPopover {...props} /> },

		headerClassName: "no-border",
	},
	{
		field: "fishingGear",
		title: t("FishingGear"),
		width: "160px",
		headerClassName: "no-border",
	},
	{
		field: "numberOfLines",
		title: t("Lines"),
		width: "80px",
		headerClassName: "no-border",
	},
	{
		field: "netLiveWeightKg",
		title: t("Weight"),
		width: "140px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} formatDecimal={2} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "electronicallySigned",
		title: "E-Sign",
		width: "60px",
		headerClassName: "no-border",
		cells: {
			data: (props) => (
				<td>{props.dataItem.electronicallySigned ? t("Yes") : t("No")}</td>
			),
		},
	},
];
